import { safeLog } from './security';

// Utility for lazy loading images
export const preloadImage = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = reject;
    img.src = src;
  });
};

// Preload critical images
export const preloadCriticalImages = async () => {
  const criticalImages = [
    '/static/media/AuthenticationBG.a40bc11c0b9765c79bfc.png',
    '/static/media/MedicalRecord.8ec7304f28833fe912b3.png',
  ];
  
  try {
    await Promise.all(criticalImages.map(preloadImage));
  } catch (error) {
    safeLog.warn('Failed to preload some images:', error);
  }
};
